import { useQuery } from '@tanstack/react-query';
import { estimatesApi } from '../services/api';
import type { GenerationEstimate } from '../types';

export function estimatesQueryKey(plantId: number, years: number[]) {
  return ['estimates', plantId, [...years].sort((a, b) => a - b).join(',')] as const;
}

// Shared across Dashboard/Historical/Planning so identical (plantId, years)
// requests hit the same React Query cache entry instead of each page
// re-fetching the same rows under its own query key.
export function useEstimates(plantId: number, years: number[], opts?: { staleTime?: number; enabled?: boolean }) {
  return useQuery<GenerationEstimate[]>({
    queryKey: estimatesQueryKey(plantId, years),
    queryFn:  () => estimatesApi.list(plantId, years).then(r => r.data.estimates),
    enabled:  years.length > 0 && (opts?.enabled ?? true),
    staleTime: opts?.staleTime,
  });
}
